uniform sampler2D uRoomDayTexture;
uniform sampler2D uRoomNightTexture;
uniform float uDayTimeMix;

varying vec2 vUv;

precision mediump float;


void main() {
    #include <colorspace_fragment>

    vec3 dayColor = texture2D(uRoomDayTexture, vUv).rgb;
    vec3 nightColor = texture2D(uRoomNightTexture, vUv).rgb;
    vec3 mixColor = mix(dayColor, nightColor, uDayTimeMix);

    gl_FragColor = vec4(mixColor, 1.0);
}
